import React from "react";

const AccountingReconciliationsTab = () => {
  return (
    <section className="bg-white border border-slate-100 rounded-xl shadow-sm p-6 space-y-3">
      <h2 className="text-lg font-semibold text-slate-900">Reconciliations</h2>
      <p className="text-sm text-slate-600">Reconcile cashbook and ledger balances with bank statements and internal control records.</p>
      <ul className="text-sm text-slate-700 list-disc list-inside space-y-1">
        <li>Match statement transactions and flag variances</li>
        <li>Track pending adjustments and corrections</li>
        <li>Close monthly reconciliation checklists</li>
      </ul>
    </section>
  );
};

export default AccountingReconciliationsTab;
